export {
    default as Question,
    IQuestionProps,
} from './question';
